import SentimentTrackerCkycContainer from "./SentimentTrackerCkycContainer";
import SentimentTrackerCkycStore from "./SentimentTrackerCkycStore";

export default SentimentTrackerCkycStore(SentimentTrackerCkycContainer);